//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
    data: function data() {
        return {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            loading: false
        };
    },
    created: function created() {
        if (process.client && this.$auth.isAuthenticated()) {
            this.$router.push({ name: 'lang', params: { lang: this.lang } });
        }
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    methods: {
        save: function save() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.loading = true;
                    axios.post(global.websiteSettings.extra_info.api_endpoint + 'api/register', {
                        name: _this.name,
                        email: _this.email,
                        password: _this.password,
                        password_confirmation: _this.password_confirmation
                    }).then(function (res) {
                        _this.loading = false;
                        _this.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                        _this.$router.push({ name: 'lang-payment', params: { lang: _this.lang } });
                        _this.$parent.$emit('login-logout-event');
                    }).catch(function (err) {
                        _this.loading = false;
                        _this.errors.clear();
                        var errors = err.response.data.errors;
                        if (errors) {
                            for (var field in errors) {
                                _this.errors.add(field, errors[field].join(', '));
                            }
                        }
                    });
                } else {
                    console.log(result);
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/old-signup-2018-03-03.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/old-signup-2018-03-03.vue
// module chunks = 36